// src/utils/downloadFile.js
// Shared helper for turning an axios blob response into a browser download.
// Used by every report export button (Employee Reports, Average Reports,
// All Reports) and can replace ad hoc download code elsewhere.

/**
 * Triggers a browser download for a blob-typed axios response.
 * Prefers the server's Content-Disposition filename when present, falling
 * back to fallbackFileName otherwise.
 */
export function downloadBlobResponse(response, fallbackFileName) {
  const blob = response.data instanceof Blob ? response.data : new Blob([response.data]);
  let fileName = fallbackFileName;

  const disposition = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'];
  if (disposition) {
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
    if (utf8Match && utf8Match[1]) {
      fileName = decodeURIComponent(utf8Match[1]);
    } else if (plainMatch && plainMatch[1]) {
      fileName = plainMatch[1];
    }
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function extensionForFormat(format) {
  return format === 'pdf' ? 'pdf' : 'xlsx';
}
